module.exports = __webpack_public_path__ + "static/media/welfare.54405bf6.png";